import { Fragment } from 'react';

import { HelpActionService as Service } from './HelpActionService';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';
import { useDialogCrup } from '../../../shared/hooks/DialogCrup';

export const List = () => {

  const header = 'hướng dẫn xử lý lỗi';
  const dataKey = 'id';
  const { render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems } = useDataTable({
    header,
    dataKey,
    columns: [
      {
        field: 'typeMessage', header: 'Loại', width: 200, matchMode: 'contains', filterType: 'dropdown', filterOptions: Service.typeAction, dataType: 'custom', customCell(rowData: any): any {
          let typeAction = Service.typeAction.find((t) => t.value === rowData.typeMessage);
          return typeAction?.label;
        }
      },
      { field: 'name', header: 'Mã thông điệp', width: 120, matchMode: 'contains' },
      { field: 'errorCode', header: 'Mã lỗi', width: 80, matchMode: 'contains' },
      {
        field: 'reason', header: 'Nguyên nhân lỗi', minWidth: 200,
        dataType: 'custom',
        customCell(rowData: any): any {
          return <div dangerouslySetInnerHTML={{ __html: rowData.reason }} />;
        }
      }
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const { render: renderDialogCrup, create, update, clone } = useDialogCrup({
    header,
    dataKey,
    width: '80rem',
    fields: [
      { field: 'typeMessage', header: 'Loại', required: true, type: 'Dropdown', DropdownProps: { options: Service.typeAction, filter: true }, className: 'md:col-4' },
      { field: 'name', header: 'Mã thông điệp', required: true, InputTextProps: { maxLength: 500 }, className: 'md:col-3' },
      { field: 'errorCode', required: true, header: 'Mã lỗi', InputTextProps: { maxLength: 500 }, className: 'md:col-3' },
      { field: 'reason', header: 'Lý do', required: true, type: 'CKEditor', className: 'md:col-12' },
      { field: 'guide', header: 'Cách xử lý', required: true, type: 'CKEditor', className: 'md:col-12' },
      { field: 'note', header: 'Khuyến nghị của M-invoice', required: true, type: 'CKEditor', className: 'md:col-12' },
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const { renderToolbar } = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
